import React from "react";

export default function KpiCard({
  label,
  value,
  icon: Icon,
  iconBg = "bg-primary",
  subtext,
  tagText,
  tagType = "positive",
}) {
  return (
    <div className="sad-kpi-card">
      {Icon && (
        <div className={`sad-kpi-icon ${iconBg} text-white`}>
          <Icon />
        </div>
      )}

      <div className="sad-kpi-info">
        <span className="sad-kpi-value">{value}</span>
        <span className="sad-kpi-label">{label}</span>
        {subtext && <span className="sad-kpi-subtext">{subtext}</span>}
      </div>
    </div>
  );
}
